export default {
  // Navbar
  nav_home: "Strona g\u0142\u00f3wna",
  nav_excursions: "Wycieczki",
  nav_reviews: "Opinie",
  nav_contact: "Obserwuj nas",
  nav_book_now: "Rezerwuj",
  nav_menu: "Menu",
  nav_whatsapp: "WhatsApp",

  // Hero
  hero_badge: "Jedno z najlepszych miejsc na zarezerwowanie przygody na Teneryfie",
  hero_title_1: "Odkryj Teneryf\u0119.",
  hero_title_2: "\u017byj przygod\u0105.",
  hero_subtitle: "Od wypraw buggy przez wulkany po najlepsze parki rozrywki \u2014 rezerwuj niezapomniane wycieczki i bilety na Wyspach Kanaryjskich z lokalnymi ekspertami, kt\u00f3rym mo\u017cesz zaufa\u0107.",
  hero_cta_explore: "Przegl\u0105daj wycieczki",
  hero_cta_talk: "Porozmawiaj z ekspertem",
  hero_badge_local_support: "Lokalna obs\u0142uga",
  hero_badge_local_support_sub: "w 3 j\u0119zykach",
  hero_badge_secure: "Bezpieczna rezerwacja",
  hero_badge_secure_sub: "zaufana i zweryfikowana",

  // Categories
  cat_title: "Przegl\u0105daj wed\u0142ug kategorii",
  cat_heading: "Ka\u017cdy rodzaj przygody na Teneryfie",
  cat_subtitle: "Od wulkanicznych w\u0119dr\u00f3wek po ogl\u0105danie wieloryb\u00f3w \u2014 nasze kategorie pomog\u0105 Ci znale\u017a\u0107 idealne do\u015bwiadczenie.",
  cat_bus: "Wycieczki autokarowe",
  cat_parks: "Parki rozrywki",
  cat_tickets: "Bilety",
  cat_boat: "Rejsy \u0142odzi\u0105",
  cat_adventure: "Przygoda i natura",
  cat_water: "Atrakcje wodne",
  cat_food: "Gastronomia",
  cat_rental: "Wynajem aut i motor\u00f3w",
  cat_activities: "atrakcji",

  // Excursions List
  el_badge: "Polecane do\u015bwiadczenia",
  el_heading: "Wybrane wycieczki na Teneryf\u0119",
  el_subtitle: "Najcz\u0119\u015bciej rezerwowane przygody w tym miesi\u0105cu \u2014 od adrenaliny po parki dla ca\u0142ej rodziny.",
  el_view_all: "Wszystkie wycieczki",
  el_explore_all_btn: "Przegl\u0105daj Wszystkie Wycieczki",
  el_explore_all_sub: "Wszystkie kategorie \u2014 przygoda, rejsy, sporty wodne i wi\u0119cej",
  exall_badge: "Wszystkie Wycieczki",
  exall_heading: "Wszystkie Wycieczki na Teneryfie",
  exall_subtitle: "Ka\u017cda przygoda, pokaz i aktywno\u015b\u0107 wodna w naszej ofercie \u2014 filtruj wed\u0142ug kategorii lub przegl\u0105daj wszystkie.",
  exall_filter_all: "Wszystkie",
  exall_results_label: "wycieczek",
  exall_no_results: "Brak wycieczek w tej kategorii.",
  el_from: "Od",
  el_view_details: "Zobacz szczeg\u00f3\u0142y",
  el_pickup: "Odbi\u00f3r",
  el_accessible: "Dost\u0119pne",

  // Why Us
  wu_badge: "Dlaczego warto u nas rezerwowa\u0107",
  wu_heading: "Tw\u00f3j zaufany partner wycieczkowy na Teneryfie",
  wu_subtitle: "Jeste\u015bmy agencj\u0105 wycieczkow\u0105 na Teneryfie z prost\u0105 misj\u0105: pokaza\u0107 Ci najlepsze strony wyspy bez turystycznych pu\u0142apek.",

  wu_local_experts: "Lokalni eksperci Teneryfy",
  wu_local_experts_body: "Agencja z siedzibą w El Médano — nasi przewodnicy żyją i oddychają tą wyspą.",
  wu_languages: "Obs\u0142uga w 3 j\u0119zykach",
  wu_languages_body: "M\u00f3wimy po polsku, angielsku i hiszpa\u0144sku. \u017badnych barier j\u0119zykowych, tylko dobra obs\u0142uga.",
  wu_handpicked: "Wyselekcjonowane do\u015bwiadczenia",
  wu_handpicked_body: "Ka\u017cda wycieczka i bilet s\u0105 osobi\u015bcie testowane i dobierane pod k\u0105tem jako\u015bci, zabawy i warto\u015bci.",
  wu_personal: "Pomoc w uk\u0142adaniu planu",
  wu_personal_body: "Nie wiesz co wybra\u0107? Napisz do nas na WhatsApp, a zbudujemy dla Ciebie spersonalizowany plan.",

  // Testimonials (homepage)
  tm_badge: "Prawdziwe Opinie",
  tm_heading: "Co mówią nasi klienci",
  tm_subtitle: "Autentyczne opinie podróżnych, którzy zarezerwowali wycieczki bezpośrednio przez nas — podzielone się na Facebooku własnymi słowami.",
  tm_based_on: "na podstawie opinii z Facebooka",
  tm_source_fb: "Polecił/a na Facebooku",
  tm_show_more: "Czytaj więcej",
  tm_show_less: "Zwiń",
  tm_see_more_fb: "Zobacz więcej opinii na Facebooku",

  // Reviews
  rev_badge: "Opinie klient\u00f3w",
  rev_heading: "Co m\u00f3wi\u0105 nasi podr\u00f3\u017cnicy",
  rev_subtitle: "Prawdziwe opinie od prawdziwych ludzi, kt\u00f3rzy zarezerwowali wycieczki u nas.",
  rev_rating_label: "zweryfikowanych opinii",
  // Customer Reviews
  rev_1_title: "Czysta adrenalina!",
  rev_1_body: "Najlepszy dzie\u0144 naszych wakacji na Teneryfie. Nasz przewodnik by\u0142 przezabawny, a wulkaniczny krajobraz jest nierealny. Polaris RZR to bestia \u2014 gor\u0105co polecam!",
  rev_2_title: "Najlepszy park jaki odwiedzili\u015bmy",
  rev_2_body: "To najlepszy park w jakim by\u0142am, zdecydowanie wart swojej ceny. Bardzo czysto, zwierz\u0119ta niesamowite, jedzenie bardzo dobre. \u015awietny dzie\u0144!",
  rev_3_title: "\u015awietna oferta \u0142\u0105czona",
  rev_3_body: "Yani pom\u00f3g\u0142 nam z rezerwacj\u0105 \u2014 bardzo mi\u0142y i pomocny. Bilet \u0142\u0105czony by\u0142 \u015bwietn\u0105 okazj\u0105 i \u015bwietnie si\u0119 bawili\u015bmy w obu parkach.",
  rev_4_title: "\u015awietna obs\u0142uga klienta",
  rev_4_body: "Personel by\u0142 niezwykle pomocny pod ka\u017cdym wzgl\u0119dem, \u015bwietna wycieczka, polecam rezerwowa\u0107 przez nich wycieczki.",
  rev_5_title: "Wszystko by\u0142o idealnie!",
  rev_5_body: "Wszystko przebieg\u0142o sprawnie, od transferu po wej\u015bcie. Oba parki s\u0105 \u015bwiatowej klasy \u2014 Siam Park szczeg\u00f3lnie nas zachwyci\u0142.",
  rev_6_title: "Wulkaniczny teren jest osza\u0142amiaj\u0105cy",
  rev_6_body: "Jazda przez ksi\u0119\u017cycowy krajobraz Teide by\u0142a surrealistyczna. Tapas i degustacja wina na koniec by\u0142y idealnym zako\u0144czeniem.",

  // Contact CTA
  ct_badge: "B\u0105d\u017a na bie\u017c\u0105co",
  ct_social_heading: "\u015aled\u017a nasze przygody",
  ct_social_subtitle: "Zobacz codzienne zdj\u0119cia, relacje i kulisy z Teneryfy. Oznacz nas na swoich wycieczkach!",
  ct_subtitle: "Powiedz nam czego szukasz \u2014 lokalny ekspert z Teneryfy odpowie w ci\u0105gu kilku godzin z spersonalizowanym planem.",
  ct_whatsapp_label: "WhatsApp",
  ct_whatsapp_number: "+48 792 842 613",
  ct_whatsapp_hours: "07:00 \u2013 21:00 codziennie",
  ct_form_heading: "Wy\u015blij do nas pro\u015b\u0119",
  ct_form_subtitle: "Stworzymy dla Ciebie idealne do\u015bwiadczenie na Teneryfie.",
  ct_form_name: "Twoje imi\u0119",
  ct_form_email: "Email",
  ct_form_interested: "Zainteresowanie",
  ct_form_date: "Preferowana data",
  ct_form_message: "Wiadomo\u015b\u0107",
  ct_form_message_placeholder: "Opowiedz nam o swojej grupie, datach, hotelu...",
  ct_form_send: "Wy\u015blij pro\u015b\u0119",
  ct_form_sending: "Wysy\u0142anie...",
  ct_success_title: "Dzi\u0119kujemy, otrzymali\u015bmy!",
  ct_success_body: "Lokalny ekspert skontaktuje si\u0119 w ci\u0105gu kilku godzin.",
  ct_form_error: "Co\u015b posz\u0142o nie tak. Spr\u00f3buj ponownie.",
  ct_form_network_error: "B\u0142\u0105d sieci. Sprawd\u017a po\u0142\u0105czenie i spr\u00f3buj ponownie.",
  ct_option_buggy: "Wyprawa Buggy na Wulkan",
  ct_option_jungle: "Bilety do Jungle Park",
  ct_option_twin: "Twin Ticket (Loro + Siam)",
  ct_option_fishing: "Morska Wyprawa Wędkarska",
  ct_option_custom: "Spersonalizowany plan",

  // Footer
  ft_tagline: "Odkryj Teneryf\u0119 z wyselekcjonowanymi wycieczkami, biletami i niezapomnianymi przygodami na wyspie. Zaufanie tysi\u0119cy podr\u00f3\u017cnych.",
  ft_contact: "Kontakt",
  ft_whatsapp: "WhatsApp",
  ft_whatsapp_number: "+48 792 842 613",
  ft_phone_local_label: "Lokalny (Teneryfa)",
  ft_hours: "07:00 \u2013 21:00 (Codziennie)",
  ft_location: "El Médano, Teneryfa, Wyspy Kanaryjskie",
  ft_explore: "Odkrywaj",
  ft_all_excursions: "Wszystkie wycieczki",
  ft_buggy: "Wyprawa Buggy na Wulkan",
  ft_jungle: "Bilety do Jungle Park",
  ft_twin: "Twin Ticket Combo",
  ft_reviews: "Opinie klient\u00f3w",
  ft_social: "Obserwuj nas",
  ft_social_text: "Wi\u0119cej zdj\u0119\u0107, historii i aktualno\u015bci na naszych kana\u0142ach spo\u0142eczno\u015bciowych.",
  ft_copyright: "\u00a9 2026 Mateo Teneryfa. Wszelkie prawa zastrze\u017cone.",
  ft_privacy: "Polityka prywatno\u015bci",
  ft_cookies: "Polityka cookies",
  ft_terms: "Regulamin",

  // Excursion page
  ex_home: "Strona g\u0142\u00f3wna",
  ex_excursions: "Wycieczki",
  ex_what_youll_do: "Co b\u0119dziesz robi\u0107",
  ex_highlights: "Najwa\u017cniejsze atrakcje",
  ex_included: "W cenie",
  ex_recommendations: "Rekomendacje",
  ex_requirements: "Wymagania",
  ex_schedule: "Harmonogram pokaz\u00f3w",
  ex_hours: "Godziny otwarcia",
  ex_languages: "Dost\u0119pne j\u0119zyki",
  ex_reviews: "Opinie klient\u00f3w",
  ex_related: "Mo\u017ce Ci si\u0119 spodoba\u0107",
  ex_more: "Wi\u0119cej do\u015bwiadcze\u0144",
  ex_see_all: "Zobacz wszystkie",
  ex_small_group: "Ma\u0142a grupa",
  ex_pickup: "Odbi\u00f3r",
  ex_accessible: "Dost\u0119pne",
  ex_duration: "Czas trwania",
  ex_yes: "Tak",
  ex_no: "Nie",
  ex_not_found_title: "Nie znaleziono wycieczki",
  ex_not_found_body: "Atrakcja, kt\u00f3rej szukasz, nie istnieje.",
  ex_back_home: "Powr\u00f3t do strony g\u0142\u00f3wnej",

  // Booking Widget
  bw_manage: "Zarz\u0105dzaj rezerwacj\u0105",
  bw_book: "Rezerwuj",
  bw_option: "Wybierz opcj\u0119",
  bw_date: "Wybierz dat\u0119",
  bw_adults: "Doro\u015bli",
  bw_children: "Dzieci",
  bw_infants: "Niemowl\u0119ta",
  bw_total: "Cena ca\u0142kowita",
  bw_add_cart: "Dodaj do koszyka",
  bw_book_now: "Rezerwuj teraz",
  bw_added_msg: "Dodano! Lokalny ekspert potwierdzi rezerwacj\u0119 w ci\u0105gu kilku godzin.",
  bw_instant: "Bezpieczna rezerwacja — zaufanie tysięcy",
  bw_secure: "Bezpieczna p\u0142atno\u015b\u0107",

  // Language
  lang_pl: "Polski",
  lang_en: "English",
  lang_es: "Espa\u00f1ol",
  lang_modal_title: "Wybierz j\u0119zyk",
  lang_modal_subtitle: "Wybierz preferowany j\u0119zyk, aby kontynuowa\u0107",

  // Booking Form Modal
  bfm_title: "Doko\u0144cz rezerwacj\u0119",
  bfm_success_title: "Zg\u0142oszenie rezerwacji wys\u0142ane!",
  bfm_success_body: "Dziękujemy! Otrzymaliśmy Twoje zgłoszenie i skontaktujemy się wkrótce.",
  bfm_excursion: "Wycieczka",
  bfm_date: "Data",
  bfm_guests: "Go\u015bcie",
  bfm_name: "Imi\u0119 i nazwisko",
  bfm_name_placeholder: "Twoje imi\u0119 i nazwisko",
  bfm_email: "Email",
  bfm_email_placeholder: "twoj@email.com",
  bfm_phone: "Telefon / WhatsApp",
  bfm_message: "Dodatkowe pro\u015bby",
  bfm_message_placeholder: "Nazwa hotelu, miejsce odbioru, wymagania dietetyczne...",
  bfm_submit: "Wy\u015blij rezerwacj\u0119",
  bfm_sending: "Wysy\u0142anie...",

  // Excursion titles
  "ex_title_buggy-volcano": "Wyprawa Buggy na Wulkan — 3 Godziny",
  "ex_title_jungle-park": "Jungle Park — Arona, Teneryfa",
  "ex_title_twin-ticket": "Podwójny Bilet — Loro Parque + Siam Park",

  // Excursion subtitles
  "ex_subtitle_buggy-volcano": "Przygoda off-road Polaris RZR wokół wulkanu Teide",
  "ex_subtitle_jungle-park": "Poznaj egzotyczną dziką przyrodę, ptaki drapieżne i majestatyczne wielkie koty",
  "ex_subtitle_twin-ticket": "Dwa z najlepszych parków rozrywki na świecie w jednym bilecie",

  // Category labels
  cat_adventure_nature: "Przygoda i Natura",
  cat_parks_tickets: "Parki i Bilety",

  // Reviews word
  ex_reviews_word: "opinii",

  // Duration per excursion
  "ex_dur_buggy-volcano": "3 godz.",
  "ex_dur_jungle-park": "4 – 5 godz.",
  "ex_dur_twin-ticket": "5 godz.",

  // Variant labels
  "ex_var_buggy-volcano_0": "Jedno buggy",
  "ex_var_buggy-volcano_1": "Podwójne buggy",
  "ex_var_jungle-park_0": "Bilet dorosły",
  "ex_var_jungle-park_1": "Dziecko (5 – 10 lat)",
  "ex_var_jungle-park_2": "Niemowlę (3 – 4 lata)",
  "ex_var_twin-ticket_0": "Twin Ticket Dorosły",
  "ex_var_twin-ticket_1": "Twin Ticket Rezydent",
  "ex_var_twin-ticket_2": "Twin Ticket + Autobus do Loro Parque",
  "ex_var_twin-ticket_3": "Transfer do Loro Parque",
  "ex_var_twin-ticket_4": "Autobus Siam z Puerto de la Cruz",

  // Schedule names (Jungle Park)
  "ex_sch_jungle-park_0": "Pokaz egzotycznych ptaków",
  "ex_sch_jungle-park_1": "Pokaz ptaków drapieżnych",
  "ex_sch_jungle-park_2": "Pokaz lwów morskich",
  "ex_sch_jungle-park_3": "Karmienie pingwinów",

  // Park hours (Twin Ticket)
  "ex_hrs_twin-ticket_0_name": "Loro Parque",
  "ex_hrs_twin-ticket_0_info": "8:30 – 18:45, 365 dni w roku",
  "ex_hrs_twin-ticket_1_name": "Siam Park (Maj – Paź)",
  "ex_hrs_twin-ticket_1_info": "10:00 – 18:00",
  "ex_hrs_twin-ticket_2_name": "Siam Park (Lis – Kwi)",
  "ex_hrs_twin-ticket_2_info": "10:00 – 17:00",

  // BookingWidget
  bw_whatsapp_support: "Wsparcie WhatsApp:",
  bw_local_phone: "Lokalny (Teneryfa):",

  // Excursion Requirements
  "ex_req_buggy-volcano_0": "Wymagane standardowe prawo jazdy",
  "ex_req_buggy-volcano_1": "Kierowcy poni\u017cej 23 lat musz\u0105 zostawi\u0107 kaucj\u0119 250 \u20ac",
  "ex_req_twin-ticket_0": "Twin Ticket korzysta z systemu cyfrowego odcisku palca",

  // Excursion Included
  "ex_inc_buggy-volcano_0": "Odbi\u00f3r i dow\u00f3z",
  "ex_inc_buggy-volcano_1": "Woda butelkowana",
  "ex_inc_buggy-volcano_2": "Gogle przeciwpy\u0142owe",
  "ex_inc_buggy-volcano_3": "Ciep\u0142e kurtki i r\u0119kawiczki (w razie potrzeby)",
  "ex_inc_buggy-volcano_4": "Podstawowe ubezpieczenie pojazdu",
  "ex_inc_buggy-volcano_5": "Niezapomniane wra\u017cenia z jazdy",
  "ex_inc_jungle-park_0": "Pe\u0142ny bilet wst\u0119pu",
  "ex_inc_jungle-park_1": "Darmowy autobus z po\u0142udniowej Teneryfy",
  "ex_inc_twin-ticket_0": "Wst\u0119p do Loro Parque",
  "ex_inc_twin-ticket_1": "Wst\u0119p do Siam Park",
  "ex_inc_twin-ticket_2": "Voucher z natychmiastowym potwierdzeniem",

  // Excursion Highlights
  "ex_hl_buggy-volcano_0": "Odbi\u00f3r i dow\u00f3z z hotelu w cenie, bezstresowy transfer",
  "ex_hl_buggy-volcano_1": "Profesjonalne szkolenie z bezpiecze\u0144stwa przed ruszeniem",
  "ex_hl_buggy-volcano_2": "15 minut czystej adrenaliny na dedykowanym torze wulkanicznym",
  "ex_hl_buggy-volcano_3": "Opcjonalna degustacja wina &amp; kanaryjskie tapas po je\u017adzie",
  "ex_hl_jungle-park_0": "Pokaz lot\u00f3w swobodnych z or\u0142ami, soko\u0142ami i ptakami drapie\u017cnymi",
  "ex_hl_jungle-park_1": "Spotkaj niesamowitego bia\u0142ego tygrysa, aligatory, ma\u0142py &amp; lwy",
  "ex_hl_jungle-park_2": "Pi\u0119knie odtworzone \u015brodowisko d\u017cungli",
  "ex_hl_jungle-park_3": "Darmowy autobus z Los Cristianos, Las Am\u00e9ricas &amp; Costa Adeje",
  "ex_hl_twin-ticket_0": "Loro Parque \u2014 najlepsze zoo na \u015bwiecie z najwi\u0119ksz\u0105 kolekcj\u0105 papug",
  "ex_hl_twin-ticket_1": "Siam Park \u2014 najwi\u0119kszy park wodny w Europie z tropikaln\u0105 stylizacj\u0105 tajsk\u0105",
  "ex_hl_twin-ticket_2": "Specjalna \u0142\u0105czona cena, oszcz\u0119dno\u015b\u0107 wzgl\u0119dem bilet\u00f3w indywidualnych",
  "ex_hl_twin-ticket_3": "15 dni wa\u017cno\u015bci mi\u0119dzy dwiema wizytami",

  // Excursion Taglines
  "ex_tagline_buggy-volcano": "Je\u017ad\u017a najpot\u0119\u017cniejszymi buggy Polaris RZR po wulkanicznych szlakach Teneryfy.",
  "ex_tagline_jungle-park": "Inny rodzaj zoo skoncentrowany na dzikiej przyrodzie d\u017cungli: ptaki drapie\u017cne, soko\u0142y, or\u0142y i egzotyczne zwierz\u0119ta wszelkiego rodzaju.",
  "ex_tagline_twin-ticket": "Bilet \u0142\u0105czony do Loro Parque i Siam Park \u2014 uznanych za najlepsze zoo i najlepszy park wodny na \u015bwiecie przez u\u017cytkownik\u00f3w TripAdvisor.",

  // Excursion Recommendations
  "ex_rec_buggy-volcano_0": "Ubierz wygodne buty i ubranie",
  "ex_rec_buggy-volcano_1": "Zabierz kurtk\u0119, w g\u00f3rach mo\u017ce by\u0107 zimno",
  "ex_rec_buggy-volcano_2": "Na\u0142\u00f3\u017c krem z filtrem \u2014 s\u0142o\u0144ce na Teneryfie jest intensywne, szczeg\u00f3lnie latem",
  "ex_rec_jungle-park_0": "Przyjed\u017a wcze\u015bnie, aby zobaczy\u0107 pokaz egzotycznych ptak\u00f3w o 11:00",
  "ex_rec_jungle-park_1": "Zalecane wygodne buty do chodzenia",
  "ex_rec_twin-ticket_0": "Zarezerwuj transfer autobusowy co najmniej 24 godziny wcze\u015bniej",
  "ex_rec_twin-ticket_1": "Darmowy poci\u0105g z Puerto de la Cruz do Loro Parque",

  // ─── Nowe kategorie
  cat_boat_trips: "Rejsy",
  cat_water_activities: "Aktywno\u015bci Wodne",
  cat_entertainment: "Rozrywka",

  // ─── Two Parks Ticket
  "ex_title_two-parks-ticket": "Bilet na Dwa Parki \u2014 Jungle Park + Aqualand",
  "ex_subtitle_two-parks-ticket": "Odwied\u017a dwa niesamowite parki rozrywki na jednym bilecie",
  "ex_tagline_two-parks-ticket": "Dwa parki, jeden bilet, zero zachodu. Jungle Park to spacer w\u015br\u00f3d bia\u0142ych tygrys\u00f3w, or\u0142\u00f3w i tropikalnych zwierz\u0105t, a Aqualand przejmuje pa\u0142eczk\u0119 z adrenalin\u0105 na zje\u017cd\u017calniach, strefami pluskania i leniw\u0105 rzek\u0105. Bilet mo\u017cesz wykorzysta\u0107 w r\u00f3\u017cne dni \u2014 nie musisz si\u0119 spieszy\u0107.",
  "ex_dur_two-parks-ticket": "6 godz.",
  "ex_hl_two-parks-ticket_0": "Spotkaj z bliska wielkie koty, ptaki drapie\u017cne i tropikalne zwierz\u0119ta w naturalnych wybiegach Jungle Park",
  "ex_hl_two-parks-ticket_1": "Najlepsze atrakcje Aqualand: gigantyczny basen z falami, kr\u0119te zje\u017cd\u017calnie i d\u0142uga leniwa rzeka",
  "ex_hl_two-parks-ticket_2": "Jeden bilet = oba parki. Wi\u0119cej kasy zostaje w kieszeni ni\u017c przy kupowaniu osobno",
  "ex_hl_two-parks-ticket_3": "Roz\u0142\u00f3\u017c wizyty na r\u00f3\u017cne dni \u2014 nie ma po\u015bpiechu",
  "ex_inc_two-parks-ticket_0": "Wst\u0119p do Jungle Park",
  "ex_inc_two-parks-ticket_1": "Wst\u0119p do Aqualand Costa Adeje",
  "ex_inc_two-parks-ticket_2": "Voucher z natychmiastowym potwierdzeniem",
  "ex_rec_two-parks-ticket_0": "Spakuj str\u00f3j k\u0105pielowy, r\u0119cznik i krem z filtrem \u2014 w Aqualand przydadz\u0105 si\u0119 wszystkie trzy",
  "ex_rec_two-parks-ticket_1": "Rano wskakuj do Jungle Park, kiedy zwierz\u0119ta s\u0105 najbardziej aktywne, a po po\u0142udniu zjed\u017a do Aqualand si\u0119 och\u0142odzi\u0107",
  "ex_var_two-parks-ticket_0": "Bilet doros\u0142y",
  "ex_var_two-parks-ticket_1": "Bilet dzieci\u0119cy",

  // ─── Jeep Safari La Gomera
  "ex_title_jeep-safari-la-gomera": "Jeep Safari \u2014 Wyspa La Gomera",
  "ex_subtitle_jeep-safari-la-gomera": "Odkryj dzik\u0105 natur\u0119 i malownicze drogi La Gomery Jeepem 4x4",
  "ex_tagline_jeep-safari-la-gomera": "Wskakujesz na poranny prom, a potem cały dzień przeciskasz się przez La Gomerę w odkrytym Jeepie 4x4. Przecinasz bananowe doliny, wędrujesz przez zamglone lasy wawrzynowe UNESCO i zatrzymujesz się w górskich wioskach, których większość turystów nigdy nie widzi. Na koniec solidny kanaryjski obiad i prom z powrotem.",
  "ex_dur_jeep-safari-la-gomera": "9 godz.",
  "ex_hl_jeep-safari-la-gomera_0": "Dolina Hermigua — tarasowe pola bananowe i senna wioska wciśnięta między dwie góry",
  "ex_hl_jeep-safari-la-gomera_1": "Laguna Grande — rozległy punkt widokowy, gdzie wyspa rozpościera się pod Tobą",
  "ex_hl_jeep-safari-la-gomera_2": "Park Narodowy Garajonay — spacer przez pradawny las wawrzynowy, który pamięta czasy dinozaurów",
  "ex_hl_jeep-safari-la-gomera_3": "Punkt widokowy Agulo — najpiękniejszy balkon wyspy, z widokiem prosto na Teide za oceanem",
  "ex_hl_jeep-safari-la-gomera_4": "Obiad w rodzinnym lokalu — prosto, swojsko i absolutnie pysznie",
  "ex_inc_jeep-safari-la-gomera_0": "Prom w obie strony",
  "ex_inc_jeep-safari-la-gomera_1": "Jeep 4x4 (max 8 osób na jednego Jeepa)",
  "ex_inc_jeep-safari-la-gomera_2": "Profesjonalny lokalny przewodnik",
  "ex_inc_jeep-safari-la-gomera_3": "Odbiór i dowóz z hotelu",
  "ex_inc_jeep-safari-la-gomera_4": "Ubezpieczenie OC",
  "ex_rec_jeep-safari-la-gomera_0": "Wygodne buty to podstawa — będziesz wsiadać i wysiadać z Jeepa cały dzień",
  "ex_rec_jeep-safari-la-gomera_1": "Odbiór z południa: pon, śr, pt. Z północy: pon i śr",
  "ex_var_jeep-safari-la-gomera_0": "Dorosły (Południe)",
  "ex_var_jeep-safari-la-gomera_1": "Dziecko 2-11 lat (Południe)",
  "ex_var_jeep-safari-la-gomera_2": "Dorosły (Północ)",
  "ex_var_jeep-safari-la-gomera_3": "Dziecko 2-11 lat (Północ)",

  // ─── Helicopter Flights
  "ex_title_helicopter-flights": "Loty Widokowe Helikopterem \u2014 Teneryfa",
  "ex_subtitle_helicopter-flights": "Odkryj Teneryf\u0119 z g\u00f3ry \u2014 5 zapieraj\u0105cych dech tras do wyboru",
  "ex_tagline_helicopter-flights": "Nic nie przygotuje Cię na to, jak Teneryfa wygląda z powietrza. W jednej chwili unosisz się nad złotymi plażami, a zaraz potem zaglądasz w krater Teide. Pięć tras do wyboru — od szybkiego kąpielowego przelotu po pełne okrążenie wulkanu. Widoki przez te wielkie okna są po prostu nierealne.",
  "ex_dur_helicopter-flights": "8 – 50 min",
  "ex_hl_helicopter-flights_0": "Pięć kompletnie różnych tras — od szybkiej 8-minutowej pętli po pełne 50-minutowe doświadczenie Teide",
  "ex_hl_helicopter-flights_1": "Krótsze loty dają ten pierwszy helikopterowy dreszczyk z pięknymi widokami plaż i klifów",
  "ex_hl_helicopter-flights_2": "Dłuższe loty zabierają Cię w głąb wyspy — wulkaniczne kratery, pola lawy i góry Teno",
  "ex_hl_helicopter-flights_3": "Okna od podłogi do sufitu, więc każde miejsce ma idealny kadr na zdjęcia i wideo",
  "ex_inc_helicopter-flights_0": "Lot widokowy helikopterem",
  "ex_inc_helicopter-flights_1": "Odprawa bezpieczeństwa i sprzęt",
  "ex_req_helicopter-flights_0": "Obowiązuje limit wagowy na lot — prosimy o kontakt przy rezerwacji",
  "ex_rec_helicopter-flights_0": "Latem miejsca znikają błyskawicznie. Jeśli masz konkretne daty, zablokuj je jak najwcześniej",
  "ex_var_helicopter-flights_0": "Wybrze\u017ce Po\u0142udniowe \u2014 8-9 min",
  "ex_var_helicopter-flights_1": "Pla\u017ce i W\u0105wozy \u2014 12-15 min",
  "ex_var_helicopter-flights_2": "Pla\u017ce, W\u0105wozy i Klify \u2014 20-22 min",
  "ex_var_helicopter-flights_3": "Pla\u017ce, W\u0105wozy, Klify i Teno \u2014 35-40 min",
  "ex_var_helicopter-flights_4": "Teide i okolice \u2014 45-50 min",

  // ─── Catamaran Dolphin Watching
  "ex_title_catamaran-dolphin-watching": "Rejs Katamaranem \u2014 Delfiny i Wieloryby 4,5 godz.",
  "ex_subtitle_catamaran-dolphin-watching": "P\u0142y\u0144 wzd\u0142u\u017c malowniczego zachodniego wybrze\u017ca i szukaj delfinów i wielorybów",
  "ex_tagline_catamaran-dolphin-watching": "Porz\u0105dne popo\u0142udnie na wodzie. Katamaran sunie na zach\u00f3d wzd\u0142u\u017c wybrze\u017ca w kierunku tych ogromnych klif\u00f3w Los Gigantes, a Ty wypatrujesz delfinów i grindwali \u2014 one tu po prostu mieszkaj\u0105, nie tylko przyp\u0142ywaj\u0105. W po\u0142owie trasy za\u0142oga rzuca kotwic\u0119 na k\u0105piel z klifami g\u00f3ruj\u0105cymi nad g\u0142ow\u0105. Odbiory we wtorki i niedziele z po\u0142udnia i p\u00f3\u0142nocy.",
  "ex_dur_catamaran-dolphin-watching": "4,5 godz.",
  "ex_hl_catamaran-dolphin-watching_0": "Rejs zachodnim wybrze\u017cem \u2014 katamaran kieruje si\u0119 prosto na klify Los Gigantes",
  "ex_hl_catamaran-dolphin-watching_1": "Delfiny i grindwale s\u0105 tu rezydentami, nie go\u015b\u0107mi \u2014 obserwacje s\u0105 bardzo cz\u0119ste",
  "ex_hl_catamaran-dolphin-watching_2": "Post\u00f3j k\u0105pielowy w po\u0142owie trasy pod samymi klifami, w absurdalnie przejrzystej wodzie",
  "ex_hl_catamaran-dolphin-watching_3": "Odbi\u00f3r z hotelu z po\u0142udnia i p\u00f3\u0142nocy w ka\u017cdy wtorek i niedziel\u0119",
  "ex_inc_catamaran-dolphin-watching_0": "Rejs katamaranem",
  "ex_inc_catamaran-dolphin-watching_1": "Przewodnik biolog morski na pok\u0142adzie",
  "ex_rec_catamaran-dolphin-watching_0": "Str\u00f3j k\u0105pielowy i r\u0119cznik s\u0105 obowi\u0105zkowe \u2014 b\u0119dziesz \u017ca\u0142owa\u0107 jak nie wskoczysz",
  "ex_rec_catamaran-dolphin-watching_1": "Te rejsy zape\u0142niaj\u0105 si\u0119 szybko, zw\u0142aszcza w sezonie. Zarezerwuj kilka dni wcze\u015bniej je\u015bli mo\u017cesz",
  "ex_var_catamaran-dolphin-watching_0": "Doros\u0142y (Po\u0142udnie)",
  "ex_var_catamaran-dolphin-watching_1": "Dziecko 5-11 lat (Po\u0142udnie)",

  // ─── Pirate Ship Los Gigantes
  "ex_title_pirate-ship-los-gigantes": "Statek Piracki \u2014 Delfiny w Los Gigantes",
  "ex_subtitle_pirate-ship-los-gigantes": "3-godzinna przygoda z portu Los Gigantes na legendarnym statku pirackim Flipper Uno",
  "ex_tagline_pirate-ship-los-gigantes": "Flipper Uno to nie jest zwyk\u0142a \u0142\u00f3d\u017a turystyczna \u2014 to prawdziwy drewniany statek piracki, kt\u00f3ry odwraca g\u0142owy za ka\u017cdym razem gdy wyp\u0142ywa z portu Los Gigantes. Trzy godziny na pok\u0142adzie: wypatrujesz delfin\u00f3w z biologiem morskim, wskakujesz do oceanu na k\u0105piel pod tymi gigantycznymi klifami, a potem siadasz do paelli, grillowanego kurczaka i zimnego drinka. Dwa rejsy dziennie, do 90 os\u00f3b, atmosfera zawsze na luzie.",
  "ex_dur_pirate-ship-los-gigantes": "3 godz.",
  "ex_hl_pirate-ship-los-gigantes_0": "Sam Flipper Uno \u2014 autentyczny drewniany statek piracki, kt\u00f3ry sta\u0142 si\u0119 ikon\u0105 Los Gigantes",
  "ex_hl_pirate-ship-los-gigantes_1": "Biolog morski p\u0142ynie z Wami, \u017ceby pom\u00f3c wypatrze\u0107 i rozpozna\u0107 delfiny i wieloryby",
  "ex_hl_pirate-ship-los-gigantes_2": "K\u0105piel tam, gdzie klify stykaj\u0105 si\u0119 z morzem \u2014 woda nie mo\u017ce by\u0107 czystsza",
  "ex_hl_pirate-ship-los-gigantes_3": "\u015awie\u017co przygotowany lunch na pok\u0142adzie: paella, kurczak, wino, piwo i napoje w cenie",
  "ex_inc_pirate-ship-los-gigantes_0": "Czerwone wino, piwo, napoje bezalkoholowe i woda na pok\u0142adzie",
  "ex_rec_pirate-ship-los-gigantes_0": "Dwa rejsy dziennie: 11:30 i 14:30. Popo\u0142udniowy \u0142apie przepi\u0119kne z\u0142ote \u015bwiat\u0142o",
  "ex_rec_pirate-ship-los-gigantes_1": "We\u017a aparat, str\u00f3j k\u0105pielowy i troch\u0119 energii \u2014 to nie jest cichy rejs widokowy",
  "ex_var_pirate-ship-los-gigantes_0": "Doros\u0142y",
  "ex_var_pirate-ship-los-gigantes_1": "Dziecko 2-11 lat",
  "ex_var_pirate-ship-los-gigantes_2": "Niemowl\u0119 0-2 lata",

  // ─── Night Skies Tenerife
  "ex_title_night-skies-tenerife": "Nocne Niebo Teneryfy \u2014 Obserwacja Gwiazd na Teide",
  "ex_subtitle_night-skies-tenerife": "Obserwuj gwiazdy przez teleskopy w niesamowitym nocnym niebie Parku Narodowego Teide",
  "ex_tagline_night-skies-tenerife": "Park Narodowy Teide le\u017cy nad chmurami, z dala od jakichkolwiek \u015bwiate\u0142 miasta \u2014 to jedno z najlepszych miejsc na Ziemi do patrzenia w gwiazdy. Przewodnik oprowadza Ci\u0119 po nocnym niebie laserem na tyle mocnym, \u017ce si\u0119ga Drogi Mlecznej, a teleskopy przybli\u017caj\u0105 pier\u015bcienie Saturna i odleg\u0142e galaktyki prosto przed Twoje oczy. Jest te\u017c opcja z zachodem s\u0142o\u0144ca, je\u015bli chcesz pe\u0142ne przej\u015bcie od z\u0142ota do gwiazd.",
  "ex_dur_night-skies-tenerife": "3 \u2013 4 godz.",
  "ex_hl_night-skies-tenerife_0": "Park Narodowy Teide po zmroku \u2014 zero zanieczyszczenia \u015bwiat\u0142em, tylko Ty i niebo pe\u0142ne gwiazd",
  "ex_hl_night-skies-tenerife_1": "Pot\u0119\u017cne zielone lasery \u2014 przewodnik dos\u0142ownie rysuje konstelacje na Drodze Mlecznej",
  "ex_hl_night-skies-tenerife_2": "Profesjonalne teleskopy ustawione tak, \u017ceby\u015b zobaczy\u0142 Saturna, Jowisza i obiekty g\u0142\u0119bokiego nieba z bliska",
  "ex_hl_night-skies-tenerife_3": "Odbi\u00f3r z hotelu na po\u0142udniu \u2014 nie musisz nawigowa\u0107 g\u00f3rskimi drogami po ciemku",
  "ex_inc_night-skies-tenerife_0": "Odbi\u00f3r i dow\u00f3z z hotelu z po\u0142udnia Teneryfy",
  "ex_inc_night-skies-tenerife_1": "Ekspert astronomii prowadz\u0105cy",
  "ex_req_night-skies-tenerife_0": "Zabierz ciep\u0142e ubranie \u2014 temperatura na wysoko\u015bci nocami mocno spada",
  "ex_req_night-skies-tenerife_1": "Zalecane wygodne obuwie na nier\u00f3wnym wulkanicznym terenie",
  "ex_rec_night-skies-tenerife_0": "Wycieczki w j\u0119zyku angielskim \u2014 hiszpa\u0144ski, niemiecki, holenderski i chi\u0144ski na \u017cyczenie",
  "ex_var_night-skies-tenerife_0": "Zach\u00f3d S\u0142o\u0144ca i Gwiazdy \u2014 W\u0142asny Transport",
  "ex_var_night-skies-tenerife_1": "Safari Gwiezdne (Bez Kolacji)",
  "ex_var_night-skies-tenerife_2": "Safari Gwiezdne (Kolacja w Cenie)",

  // ─── Ol\u00e9 Flamenco Show
  "ex_title_ole-flamenco-show": "Pokaz Flamenco Ol\u00e9 \u2014 Costa Adeje",
  "ex_subtitle_ole-flamenco-show": "Wiecz\u00f3r hiszpa\u0144skiego ta\u0144ca, pasji i kolor\u00f3w w Hotel GF Victoria",
  "ex_tagline_ole-flamenco-show": "Czwartkowe wieczory w Hotelu GF Victoria należą do flamenco. Show prowadzi Fran Chafino, tancerz który występował w całej Hiszpanii, a jego zespół daje z siebie wszystko — tupanie nóg, wysoki śpiew, gitara na żywo i czyste emocje. Możesz wziąć bilet Oro na sam pokaz albo Platino z kolacją przed kurtyną. W obu przypadkach bądź na miejscu do 20:30.",
  "ex_dur_ole-flamenco-show": "2 godz.",
  "ex_hl_ole-flamenco-show_0": "Zespół taneczny Frana Chafino — to poważni artyści, nie turystyczny dinner show",
  "ex_hl_ole-flamenco-show_1": "Pełne spektrum flamenco: solowe utwory gitarowe, grupowe układy taneczne i momenty wokalne które ściskają za serce",
  "ex_hl_ole-flamenco-show_2": "W każdy czwartek w Hotelu GF Victoria w Costa Adeje — recepcja od 20:30",
  "ex_hl_ole-flamenco-show_3": "Oro na sam spektakl, Platino jeśli chcesz kolację przed rozpoczęciem",
  "ex_inc_ole-flamenco-show_0": "Wstęp na pokaz flamenco",
  "ex_req_ole-flamenco-show_0": "Zakaz fotografowania i filmowania podczas spektaklu",
  "ex_rec_ole-flamenco-show_0": "Pokaz startuje punkt 21:00. Bądź na miejscu do 20:30, żeby złapać drinka i się rozgościć",
  "ex_rec_ole-flamenco-show_1": "Smart casual to strzał w dziesiątkę — jesteś w eleganckim hotelu, nie na plaży",
  "ex_var_ole-flamenco-show_0": "Oro \u2014 Doros\u0142y",
  "ex_var_ole-flamenco-show_1": "Oro \u2014 Dziecko (3-11 lat)",
  "ex_var_ole-flamenco-show_2": "Platino \u2014 Doros\u0142y",
  "ex_var_ole-flamenco-show_3": "Platino \u2014 Dziecko (3-11 lat)",

  // ─── Jet Ski Los Gigantes
  "ex_title_jet-ski-los-gigantes": "Jet Ski Los Gigantes \u2014 B\u0142\u0119kitne Safari",
  "ex_subtitle_jet-ski-los-gigantes": "Prowadzona trasa jet ski od Los Gigantes do Punta de Teno z dwoma przystankami",
  "ex_tagline_jet-ski-los-gigantes": "Godzina na skuterze wodnym wzdłuż najdzikszego odcinka wybrzeża Teneryfy. Startujesz z portu Los Gigantes z przewodnikiem na czele, przecinasz Atlantyk w kierunku wąwozu Masca, a potem pchasz się dalej do Punta de Teno — odległego przylądka, gdzie wyspa się kończy i przed Tobą już tylko ocean. Dwa postoje po drodze, żeby złapać oddech, zrobić zdjęcia i nasiąknąć widokiem.",
  "ex_dur_jet-ski-los-gigantes": "1 godz.",
  "ex_hl_jet-ski-los-gigantes_0": "Start z portu Los Gigantes i jazda prosto w stronę Barranco de Masca",
  "ex_hl_jet-ski-los-gigantes_1": "Dwa postoje po drodze — wąwóz Masca i dramatyczna latarnia Punta de Teno",
  "ex_hl_jet-ski-los-gigantes_2": "Jedź sam lub weź kogoś z tyłu — skutery pojedyncze i podwójne do wyboru",
  "ex_hl_jet-ski-los-gigantes_3": "Pianki neoprenowe, kapoki i pełna odprawa bezpieczeństwa zanim dotkniesz wody",
  "ex_inc_jet-ski-los-gigantes_0": "Kamizelka ratunkowa",
  "ex_inc_jet-ski-los-gigantes_1": "Kombinezon neoprenowy",
  "ex_inc_jet-ski-los-gigantes_2": "Szatnia",
  "ex_inc_jet-ski-los-gigantes_3": "Szafka na rzeczy",
  "ex_inc_jet-ski-los-gigantes_4": "Ręcznik",
  "ex_inc_jet-ski-los-gigantes_5": "Prysznice",
  "ex_inc_jet-ski-los-gigantes_6": "Odprawa bezpieczeństwa",
  "ex_inc_jet-ski-los-gigantes_7": "Ubezpieczenie OC i od wypadków",
  "ex_req_jet-ski-los-gigantes_0": "Minimalna wysokość do jazdy: 1,35 m",
  "ex_req_jet-ski-los-gigantes_1": "Maksymalna waga na jet ski: 200 kg",
  "ex_req_jet-ski-los-gigantes_2": "Wymagana podstawowa umiejętność pływania",
  "ex_req_jet-ski-los-gigantes_3": "Niezalecane dla kobiet w ciąży oraz osób z problemami sercowymi, kręgosłupem lub stawami",
  "ex_var_jet-ski-los-gigantes_0": "Jet ski indywidualny",
  "ex_var_jet-ski-los-gigantes_1": "Jet ski podw\u00f3jny",

  // ─── VIP Private Tour Tenerife
  "ex_title_vip-tour-tenerife": "Wycieczka VIP po Teneryfie",
  "ex_subtitle_vip-tour-tenerife": "Odkryj prawdziw\u0105 Teneryf\u0119 we w\u0142asnym tempie z prywatnym przewodnikiem",
  "ex_tagline_vip-tour-tenerife": "Zapomnij o sztywnych rozkładach autokarów i zatłoczonych punktach widokowych. To Twój własny samochód z kierowcą-przewodnikiem, który zna każdą boczną drogę, ukryty punkt widokowy i rodzinną knajpkę na wyspie. Ty decydujesz — zatrzymujesz się na zdjęcia kiedy chcesz, omijasz to co Cię nie interesuje, zostajesz dłużej tam gdzie Ci się podoba. Osiem godzin Teneryfy po Twojemu.",
  "ex_dur_vip-tour-tenerife": "8 godz.",
  "ex_hl_vip-tour-tenerife_0": "Tylko Ty i Twoja grupa — żadnych obcych, żadnego czekania na innych",
  "ex_hl_vip-tour-tenerife_1": "Przewodnik zabiera Cię w miejsca, do których duże autokary nie dojadą — ciche punkty widokowe i lokalne sekrety",
  "ex_hl_vip-tour-tenerife_2": "Trasa nagina się do Twoich zainteresowań, nie na odwrót. Zmień plany w połowie dnia jeśli masz ochotę",
  "ex_hl_vip-tour-tenerife_3": "Wygodny prywatny samochód, obsługa od drzwi do drzwi i przewodnik który faktycznie słucha czego chcesz",
  "ex_hl_vip-tour-tenerife_4": "Odbiór z każdego miejsca na wyspie — hotelu, apartamentu, nawet lotniska",
  "ex_inc_vip-tour-tenerife_0": "Prywatny pojazd z kierowcą-przewodnikiem",
  "ex_inc_vip-tour-tenerife_1": "Odbiór z dowolnego miejsca na wyspie",
  "ex_rec_vip-tour-tenerife_0": "Wycieczki odbywają się od poniedziałku do piątku",
  "ex_rec_vip-tour-tenerife_1": "Dopłata 30€ za odbiór z Puerto de La Cruz, Santa Cruz i Candelaria",
  "ex_var_vip-tour-tenerife_0": "2 osoby",
  "ex_var_vip-tour-tenerife_1": "3 osoby",
  "ex_var_vip-tour-tenerife_2": "4 osoby",
  "ex_var_vip-tour-tenerife_3": "5 i wi\u0119cej os\u00f3b",

  // ─── Kayak Los Gigantes
  "ex_title_kayak-los-gigantes": "Kajak Los Gigantes \u2014 Klify i Ocean",
  "ex_subtitle_kayak-los-gigantes": "Odkryj majestatyczne klify Los Gigantes kajakiem \u2014 surowe do\u015bwiadczenie oceaniczne",
  "ex_tagline_kayak-los-gigantes": "Wiosłowanie kajakiem pod tymi 600-metrowymi klifami działa na wyobraźnię — z poziomu wody nie wyglądają jak coś prawdziwego. Krótki transfer łodzią zabiera Cię z portu do punktu startowego, a potem dwie godziny suniesz wzdłuż podstawy Los Gigantes, zaglądasz do ukrytych zatoczek i dryfujesz po wodzie tak przejrzystej, że widać dno. Tylko małe grupy, a popołudniowe światło sprawia, że ściany skalne dosłownie świecą.",
  "ex_dur_kayak-los-gigantes": "2 godz.",
  "ex_hl_kayak-los-gigantes_0": "Wiosłuj tuż pod klifami — praktycznie możesz dotknąć wulkanicznej skały",
  "ex_hl_kayak-los-gigantes_1": "Klify opadają 600 metrów prosto do oceanu. Z kajaka robią jeszcze większe wrażenie",
  "ex_hl_kayak-los-gigantes_2": "Kameralne grupy, żeby nigdy nie było tłoczno ani pośpiesznie",
  "ex_hl_kayak-los-gigantes_3": "Transfer łodzią z portu do strefy pływania i z powrotem — żadnego męczącego dopływania",
  "ex_inc_kayak-los-gigantes_0": "Napoje",
  "ex_inc_kayak-los-gigantes_1": "Prysznic",
  "ex_inc_kayak-los-gigantes_2": "Sprzęt kajakowy",
  "ex_inc_kayak-los-gigantes_3": "Transfer łodzią do miejsca kajakowania i z powrotem",
  "ex_req_kayak-los-gigantes_0": "Wymagana umiejętność pływania",
  "ex_req_kayak-los-gigantes_1": "Niezalecane dla osób z problemami kręgosłupa lub stawów",
  "ex_var_kayak-los-gigantes_0": "Doros\u0142y \u2014 sesja 13:00",
  "ex_var_kayak-los-gigantes_1": "Dziecko (6-9 lat) \u2014 sesja 13:00",

  // Paralotnia Teneryfa
  "ex_title_paragliding-tenerife": "Paralotnia Teneryfa \u2014 Loty Tandemowe",
  "ex_subtitle_paragliding-tenerife": "Loty tandemowe nad atlantyckim wybrze\u017cem \u2014 Br\u0105z, Silver i Akrobatyczny",
  "ex_tagline_paragliding-tenerife": "Ma\u0142o jest na \u015bwiecie uczu\u0107 por\u00f3wnywalnych z odbiciem si\u0119 od g\u00f3ry i szybowaniem nad Atlantykiem z Teneryf\u0105 rozci\u0105gni\u0119t\u0105 pod Twoimi stopami. Lot Podstawowy \u2014 10\u201320 min z 800 m, idealny na pocz\u0105tek. Lot Silver wyd\u0142u\u017ca do 20\u201340 min, z opcj\u0105 startu z Ifonche (1000 m). Lot Akrobatyczny to spirale i wingovery nad oceanem. Do ka\u017cdego lotu +30\u20ac za pakiet zdj\u0119\u0107 i film\u00f3w.",
  "ex_dur_paragliding-tenerife": "10 \u2013 40 min",
  "ex_hl_paragliding-tenerife_0": "Lot Podstawowy / Br\u0105zowy 110\u20ac \u2014 start z 800 m, 10\u201320 minut, idealny dla pierwszego lotu",
  "ex_hl_paragliding-tenerife_1": "Lot D\u0142u\u017cszy / Silver 130\u20ac \u2014 start z 800 m lub Ifonche (1000 m), 20\u201340 minut. Start z Ifonche = automatycznie Silver",
  "ex_hl_paragliding-tenerife_2": "Lot Akrobatyczny 140\u20ac \u2014 maksymalna wysoko\u015b\u0107, spirale i wingovery nad oceanem dla poszukiwaczy adrenaliny",
  "ex_hl_paragliding-tenerife_3": "Pakiet zdj\u0119\u0107 i film\u00f3w +30\u20ac \u2014 dost\u0119pny do ka\u017cdego lotu",
  "ex_hl_paragliding-tenerife_4": "Lecisz w tandemie z certyfikowanym instruktorem \u2014 \u017cadne do\u015bwiadczenie nie jest potrzebne",
  "ex_inc_paragliding-tenerife_0": "Lot tandemowy z certyfikowanym instruktorem",
  "ex_inc_paragliding-tenerife_1": "Uprz\u0105\u017c paralotniowa i sprz\u0119t bezpiecze\u0144stwa",
  "ex_inc_paragliding-tenerife_2": "Odprawa bezpiecze\u0144stwa przed lotem",
  "ex_req_paragliding-tenerife_0": "Limit wagowy: 30\u2013110 kg na pasa\u017cera \u2014 poinformuj nas przy rezerwacji",
  "ex_req_paragliding-tenerife_1": "Niezalecane dla os\u00f3b z chorobami serca lub silnym l\u0119kiem wysoko\u015bci",
  "ex_rec_paragliding-tenerife_0": "Ubierz wygodne buty z zakrytymi palcami i cienkie warstwy \u2014 na wysoko\u015bci mo\u017ce wia\u0107",
  "ex_rec_paragliding-tenerife_1": "Loty zale\u017c\u0105 od pogody \u2014 potwierdzamy termin dzie\u0144 wcze\u015bniej",
  "ex_var_paragliding-tenerife_0": "Lot Podstawowy / Br\u0105zowy \u2014 10-20 min",
  "ex_var_paragliding-tenerife_1": "Lot D\u0142u\u017cszy / Silver \u2014 20-40 min",
  "ex_var_paragliding-tenerife_2": "Lot Akrobatyczny \u2014 maks. wysoko\u015b\u0107",
  "ex_var_paragliding-tenerife_3": "+ Pakiet Zdj\u0119\u0107 i Film\u00f3w (do ka\u017cdego lotu)",

  // ─── Rejs Jachtem Puerto Colón ───────────────────────────────────────────
  "ex_title_yacht-cruise-puerto-colon": "Rejs Jachtem \u2014 3 Godziny z Puerto Col\u00f3n",
  "ex_subtitle_yacht-cruise-puerto-colon": "Ekskluzywny 3-godzinny rejs jachtem z napojami, winem, piwem i kąpielą w oceanie",
  "ex_tagline_yacht-cruise-puerto-colon": "Trzy godziny na pok\u0142adzie prywatnego jachtu z Puerto Col\u00f3n \u2014 i maksymalnie 11 os\u00f3b na pok\u0142adzie, wi\u0119c je\u015bli wybierzecie si\u0119 ca\u0142\u0105 ekip\u0105, macie praktycznie prywatny jacht. W planie: rejs w poszukiwaniu delfin\u00f3w, wieloryb\u00f3w i orek, post\u00f3j przy urokliwej pla\u017cy na k\u0105piel w oceanie, a do tego napoje, winko i piwko w cenie. Relaks, s\u0142o\u0144ce i niezapomniane widoki gwarantowane.",
  "ex_dur_yacht-cruise-puerto-colon": "3 godz.",
  "ex_hl_yacht-cruise-puerto-colon_0": "Rejs w poszukiwaniu delfin\u00f3w, wieloryb\u00f3w i orek \u2014 te wody t\u0119tni\u0105 \u017cyciem",
  "ex_hl_yacht-cruise-puerto-colon_1": "Post\u00f3j przy urokliwej pla\u017cy na k\u0105piel w krystalicznie czystym oceanie",
  "ex_hl_yacht-cruise-puerto-colon_2": "Maksymalnie 11 os\u00f3b na pok\u0142adzie \u2014 kameralna atmosfera, \u017cadnych t\u0142um\u00f3w",
  "ex_hl_yacht-cruise-puerto-colon_3": "Napoje, wino i piwo w cenie \u2014 pop\u0142y\u0144cie w dobrym stylu",
  "ex_inc_yacht-cruise-puerto-colon_0": "3-godzinny rejs jachtem",
  "ex_inc_yacht-cruise-puerto-colon_1": "Napoje, wino i piwo na pok\u0142adzie",
  "ex_inc_yacht-cruise-puerto-colon_2": "Post\u00f3j k\u0105pielowy przy pla\u017cy",
  "ex_rec_yacht-cruise-puerto-colon_0": "Zabierz str\u00f3j k\u0105pielowy, r\u0119cznik i krem z filtrem \u2014 b\u0119dziesz wchodzi\u0107 do wody",
  "ex_rec_yacht-cruise-puerto-colon_1": "Je\u015bli jeste\u015bcie wi\u0119ksz\u0105 grup\u0105 (8\u201311 os\u00f3b), rezerwujcie z wyprzedzeniem \u2014 miejsca znikaj\u0105 b\u0142yskawicznie",
  "ex_var_yacht-cruise-puerto-colon_0": "Osoba dorosła",

  // ─── Aqualand Costa Adeje
  "ex_title_aqualand-costa-adeje": "Aqualand Costa Adeje — Park Wodny",
  "ex_subtitle_aqualand-costa-adeje": "Największy park wodny na południu Teneryfy z delfinarium",
  "ex_tagline_aqualand-costa-adeje": "Aqualand to nie jest zwykły park wodny — ma własne delfinarium z 10 delfinami urodzonymi w parku. Kamikaze, Super Slalom, Twister, Anaconda, Crazy Race i nowiutki Boomerang czekają na tych, którzy chcą adrenaliny. Darmowy autobus z Los Cristianos, Las Américas i Costa Adeje. Godziny: wrzesień–czerwiec 10:00–17:30, lipiec–sierpień 10:00–18:00.",
  "ex_dur_aqualand-costa-adeje": "4 – 5 godz.",
  "ex_hl_aqualand-costa-adeje_0": "Własne delfinarium z spektaklem — delfiny to gwiazdy parku",
  "ex_hl_aqualand-costa-adeje_1": "Kamikaze, Super Slalom, Twister, Anaconda — klasyczne zjeżdżalnie plus nowiutki Boomerang",
  "ex_hl_aqualand-costa-adeje_2": "Mini Park dla najmłodszych — bezpieczna strefa wodna dla dzieci",
  "ex_hl_aqualand-costa-adeje_3": "Darmowy autobus z Los Cristianos, Las Américas i Costa Adeje",
  "ex_inc_aqualand-costa-adeje_0": "Wstęp do parku",
  "ex_inc_aqualand-costa-adeje_1": "Darmowy autobus z południowej Teneryfy",
  "ex_rec_aqualand-costa-adeje_0": "Sprawdź godziny spektaklu delfinów — wrzesień–czerwiec 15:30, lipiec–sierpień 12:45 i 15:30",
  "ex_rec_aqualand-costa-adeje_1": "Park zamyka się o 17:30 zimą i o 18:00 latem — zaplanuj wyjście z odpowiednim marginesem",
  "ex_var_aqualand-costa-adeje_0": "Bilet dorosły",
  "ex_var_aqualand-costa-adeje_1": "Dziecko (5–10 lat)",
  "ex_var_aqualand-costa-adeje_2": "Niemowlę (3–4 lata)",

  // ─── Siam Park
  "ex_title_siam-park-tenerife": "Siam Park — Najlepszy Park Wodny Świata",
  "ex_subtitle_siam-park-tenerife": "7 razy z rzędu najlepszy park wodny świata wg TripAdvisor",
  "ex_tagline_siam-park-tenerife": "Siam Park zdobył tytuł najlepszego parku wodnego świata siedem razy z rzędu. Tower of Power to 28-metrowy tobogan kończący się pod wodą pełną rekinów i płaszczek. Singha to najszybsza kolejka wodna świata z 14 zmianami kierunku. Siam Beach to 13 000 m² plaży z białym piaskiem i basenem z falami. Hamaki i parasole w cenie biletu. Godziny: lato 10–18, zima 10–17.",
  "ex_dur_siam-park-tenerife": "5 godz.",
  "ex_hl_siam-park-tenerife_0": "Tower of Power — 28-metrowy tobogan przez akwarium z rekinami i płaszczkami",
  "ex_hl_siam-park-tenerife_1": "Singha — najszybsza na świecie kolejka wodna z 14 zmianami kierunku",
  "ex_hl_siam-park-tenerife_2": "Siam Beach — 13 000 m² plaży z białym piaskiem i basenem z falami. Hamaki w cenie biletu",
  "ex_hl_siam-park-tenerife_3": "Coco Beach — osobna strefa wodna dla małych dzieci z bezpiecznymi atrakcjami",
  "ex_inc_siam-park-tenerife_0": "Bilet wstępu",
  "ex_inc_siam-park-tenerife_1": "Hamaki i parasole przez cały dzień",
  "ex_rec_siam-park-tenerife_0": "Warto przyjść zaraz po otwarciu — kolejki na Tower of Power są najkrótsze z rana",
  "ex_rec_siam-park-tenerife_1": "Bilety na autobus z Puerto de la Cruz trzeba zamawiać z wyprzedzeniem",
  "ex_hrs_siam-park-tenerife_0_name": "Lato (Maj – Paź)",
  "ex_hrs_siam-park-tenerife_0_info": "10:00 – 18:00",
  "ex_hrs_siam-park-tenerife_1_name": "Zima (Lis – Kwi)",
  "ex_hrs_siam-park-tenerife_1_info": "10:00 – 17:00",
  "ex_var_siam-park-tenerife_0": "Bilet dorosły",
  "ex_var_siam-park-tenerife_1": "Bilet rezydent",
  "ex_var_siam-park-tenerife_2": "Transfer z Puerto de la Cruz",

  // ─── Loro Parque
  "ex_title_loro-parque-tenerife": "Loro Parque — Najlepsze ZOO Świata",
  "ex_subtitle_loro-parque-tenerife": "Sanktuarium 400+ gatunków zwierząt ze spektaklami orek, delfinów i papug",
  "ex_tagline_loro-parque-tenerife": "Loro Parque to nie Twoje zwykłe zoo. Każde zwierzę ma opracowany przez weterynarzy indywidualny plan opieki. Orki, delfiny, lwy morskie, papugi, tygrysy, pingwiny — w sumie ponad 400 gatunków w pięknych ogrodach w Puerto de la Cruz. Spektakle kilka razy dziennie. I tak, to naprawdę jest najlepsze zoo na świecie według TripAdvisor.",
  "ex_dur_loro-parque-tenerife": "5 godz.",
  "ex_hl_loro-parque-tenerife_0": "Pokaz orek — dwa razy dziennie o 11:55 i 15:15, niesamowity spektakl siły i inteligencji",
  "ex_hl_loro-parque-tenerife_1": "Pokaz delfinów, lwów morskich i papug — każdy pokaz 20 minut, plan w cenie biletu",
  "ex_hl_loro-parque-tenerife_2": "Tygrysy białe, aligatory, goryle, pingwiny i ponad 400 innych gatunków",
  "ex_hl_loro-parque-tenerife_3": "Darmowy autobus z południa Teneryfy lub transfer bezpośrednio z hotelu",
  "ex_inc_loro-parque-tenerife_0": "Pełny bilet wstępu",
  "ex_rec_loro-parque-tenerife_0": "Przyjedź wcześniej — wejście od 9:30. Pierwszy pokaz orek o 11:55",
  "ex_rec_loro-parque-tenerife_1": "Darmowy pociąg łączy port w Puerto de la Cruz z parkiem — wysiądź na przystanku Loro Parque",
  "ex_var_loro-parque-tenerife_0": "Bilet dorosły",
  "ex_var_loro-parque-tenerife_1": "Bilet rezydent",
  "ex_var_loro-parque-tenerife_2": "Bilet + autobus",
  "ex_var_loro-parque-tenerife_3": "Transfer",
  "ex_sch_loro-parque-tenerife_0": "Pokaz Lwów Morskich",
  "ex_sch_loro-parque-tenerife_1": "Loro Show (papugi)",
  "ex_sch_loro-parque-tenerife_2": "Pokaz Delfinów",
  "ex_sch_loro-parque-tenerife_3": "Pokaz Orek",

  // ─── Castillo San Miguel
  "ex_title_castillo-san-miguel": "Castillo San Miguel — Wieczór Średniowieczny",
  "ex_subtitle_castillo-san-miguel": "Turniej rycerski z ucztą i spektaklem w zamku hrabiego Don Rodrigo",
  "ex_tagline_castillo-san-miguel": "Wchodzisz do zamku Don Rodrigo, słyszysz kłąskáć kopyta i widzisz arenę piaskową długą na 50 metrów. Rycerze w pełnych zbrojach wchodzą na konie, publiczność kibicuje swojemu bohaterowi — a ty jesz podaną rękoma kurczę i pijesz wino prosto z dzbanka. Tak. Dokładnie takie średniowiecze jak w filmach. Pokazy we wtorki, czwartki i soboty.",
  "ex_dur_castillo-san-miguel": "3 godz.",
  "ex_hl_castillo-san-miguel_0": "Autentyczny turniej konny na 50-metrowej arenie — kibicujesz jednemu z 6 rycerzy",
  "ex_hl_castillo-san-miguel_1": "Uczta średniowieczna: rossoł z miski, kurczak jedzony rękami, wino i sok bez ograniczeń",
  "ex_hl_castillo-san-miguel_2": "Po turnieju — Sala Balowa z muzyką i taneczną atmosferą",
  "ex_hl_castillo-san-miguel_3": "Transfer z hotelu z południa Teneryfy dostępny w opcji z transportem",
  "ex_inc_castillo-san-miguel_0": "Wstęp na spektakl",
  "ex_inc_castillo-san-miguel_1": "Kolacja średniowieczna z winem i sokami",
  "ex_req_castillo-san-miguel_0": "Pokazy tylko we wtorki, czwartki i soboty. Recepcja od 18:30, spektakl od 19:30",
  "ex_rec_castillo-san-miguel_0": "Zarezerwuj transfer — lokalizacja jest poza centrum, trudno dotrzeć taksówką na czas",
  "ex_rec_castillo-san-miguel_1": "Dostępne menu wegetariańskie — poinformuj nas przy rezerwacji",
  "ex_var_castillo-san-miguel_0": "Pokaz + Kolacja",
  "ex_var_castillo-san-miguel_1": "Pokaz + Kolacja VIP",
  "ex_var_castillo-san-miguel_2": "Pokaz + Kolacja + Transfer",

  // ─── Sea Fishing Trip
  "ex_title_sea-fishing-tenerife": "Morska Wyprawa Wędkarska — Teneryfa",
  "ex_subtitle_sea-fishing-tenerife": "Cała łódź tylko dla Was — wędkarstwo morskie z południa Teneryfy",
  "ex_tagline_sea-fishing-tenerife": "Wskakujcie na pokład i spędźcie niezapomniane godziny na morzu. Cała łódź tylko dla Was, maksymalnie 4 osoby, 120 € za godzinę. Idealna opcja dla rodziny, paczki znajomych albo małej grupy wędkarzy. Nie liczy się doświadczenie — liczy się dobra zabawa, morze i emocje na pokładzie!",
  "ex_dur_sea-fishing-tenerife": "3 – 4 godz.",
  "ex_hl_sea-fishing-tenerife_0": "Cała łódź tylko dla Was — prywatna wyprawa, maksymalnie 4 osoby na pokładzie",
  "ex_hl_sea-fishing-tenerife_1": "120 € / godz. — elastyczny czas: 3 godziny (360 €) lub 4 godziny (480 €)",
  "ex_hl_sea-fishing-tenerife_2": "Wędkarstwo morskie z południa Teneryfy z doświadczonym skipperem i pełnym sprzętem",
  "ex_hl_sea-fishing-tenerife_3": "Nie wymaga doświadczenia — skipper prowadzi, Wy się bawicie i łowicie ryby",
  "ex_inc_sea-fishing-tenerife_0": "Prywatna łódź z doświadczonym skipperem",
  "ex_inc_sea-fishing-tenerife_1": "Pełny zestaw wędkarski i przynęty",
  "ex_inc_sea-fishing-tenerife_2": "Napoje na pokładzie",
  "ex_inc_sea-fishing-tenerife_3": "Pomoc w przygotowaniu złowionych ryb",
  "ex_rec_sea-fishing-tenerife_0": "Zabierz krem z filtrem, czapkę i okulary przeciwsłoneczne — na morzu słońce jest intensywne",
  "ex_rec_sea-fishing-tenerife_1": "Wygodne buty z antypoślizgową podeszwą — pokład może być mokry",
  "ex_req_sea-fishing-tenerife_0": "Wymagana podstawowa umiejętność pływania",
  "ex_var_sea-fishing-tenerife_0": "3 godziny",
  "ex_var_sea-fishing-tenerife_1": "4 godziny",

  // ─── Anaga Mountain Hike
  "ex_title_anaga-mountain-hike": "Wędrówka po magicznych górach Anaga",
  "ex_subtitle_anaga-mountain-hike": "Krótka, intensywna wędrówka przez tajemniczy las laurowy i spektakularne widoki",
  "ex_tagline_anaga-mountain-hike": "Wyruszamy w kameralnej grupie i odkrywamy jedno z najbardziej niezwykłych miejsc Teneryfy. Czeka na Ciebie tajemniczy las laurowy, mgła unosząca się między paprociami i spektakularne widoki na doliny i wąwozy. To krótka, intensywna dawka natury, która zostaje w pamięci na długo!",
  "ex_dur_anaga-mountain-hike": "2,5 – 3 godz.",
  "ex_hl_anaga-mountain-hike_0": "Tajemniczy las laurowy — pradawna przyroda wpisana na listę UNESCO",
  "ex_hl_anaga-mountain-hike_1": "Mgła, paprocie i wyjątkowy, niemal bajkowy klimat wąwozów Anagi",
  "ex_hl_anaga-mountain-hike_2": "Spektakularne widoki na doliny i wąwozy z górskich punktów widokowych",
  "ex_hl_anaga-mountain-hike_3": "Kameralna grupa — maksymalnie 10 osób, żeby zachować intymną atmosferę",
  "ex_inc_anaga-mountain-hike_0": "Doświadczony lokalny przewodnik górski",
  "ex_inc_anaga-mountain-hike_1": "Wędrówka w kameralnej grupie (max 10 osób)",
  "ex_inc_anaga-mountain-hike_2": "Ubezpieczenie podczas wędrówki",
  "ex_req_anaga-mountain-hike_0": "Podstawowa kondycja fizyczna — poziom łatwy do średniego",
  "ex_req_anaga-mountain-hike_1": "Woda i przekąski we własnym zakresie",
  "ex_rec_anaga-mountain-hike_0": "Wygodne buty trekkingowe to podstawa — trasa prowadzi leśnymi ścieżkami",
  "ex_rec_anaga-mountain-hike_1": "Zabierz lekką kurtkę i warstwy — w lesie laurowym jest mgliście i wilgotno",
  "ex_rec_anaga-mountain-hike_2": "Transport do punktu startowego ustalany indywidualnie — zapytaj przy rezerwacji",
  "ex_var_anaga-mountain-hike_0": "Osoba (min. 3 osoby)",
};